import { useEffect, useState } from "react";
import { readStepPlans, type ThreadStepPlan } from "../../../../api/threads/threadsApi";

const NO_PLANS: ReadonlyMap<string, ThreadStepPlan> = new Map();

/**
 * Each step of the Thread's Workflow as module B plans it with what has run (ADR-0032 D7;
 * Johannes, 27 Oct, point 8), read again whenever the log moves. The last plans stay in view
 * until the next arrive, so a new entry does not blank the current step; a failed read keeps
 * them, and the next entry reads again. Empty while none is read or for a free Thread.
 */
export function useStepPlans(threadId: string, lastEntryNumber: number, followsWorkflow: boolean): ReadonlyMap<string, ThreadStepPlan> {
  const [read, setRead] = useState<{ readonly threadId: string; readonly plans: ReadonlyMap<string, ThreadStepPlan> } | null>(null);
  useEffect(() => {
    if (!followsWorkflow) return undefined;
    const controller = new AbortController();
    readStepPlans(threadId, null, controller.signal).then(
      (plans) => { setRead({ threadId, plans: new Map(plans.map((plan) => [plan.stepKey, plan])) }); },
      () => undefined,
    );
    return () => { controller.abort(); };
  }, [threadId, lastEntryNumber, followsWorkflow]);
  return followsWorkflow && read?.threadId === threadId ? read.plans : NO_PLANS;
}
